import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'smart-router-animation-wrap',
  templateUrl: './smart-router-animation-wrap.component.html',
  styleUrls: ['./smart-router-animation-wrap.component.scss'],
})
export class SmartRouterAnimationWrapComponent{
  @Input() circleLoading = false;
  styles: Partial<CSSStyleDeclaration> = {
    maxWidth: '500px',
    margin: '0 auto',
  };

  constructor() {}
}
